import * as Sentry from '@sentry/nextjs';
import Bowser from 'bowser';
import fetchFromElectron from '../fetchFromElectron';

interface IOsInfo {
  name: string | undefined;
  version: string | undefined;
}
export const extractUserAgentInfo = (
  userAgent: string,
): IOsInfo | undefined => {
  try {
    const result = Bowser.parse(userAgent);

    if (result.os.name === 'Chrome OS' && !result.os.version) {
      return {
        name: result.os.name,
        version: result.browser.version,
      };
    }

    return {
      name: result.os.name,
      version: undefined,
    };
  } catch (err: unknown) {
    Sentry.captureException(err);
    // eslint-disable-next-line no-console
    console.error('Error while fetching OS version:', err);
  }
  return undefined;
};

const getOsInfo = async (
  userAgent: string,
  registrationDetails?: string,
): Promise<IOsInfo | undefined> => {
  const osInfo = extractUserAgentInfo(userAgent);
  if (osInfo) {
    if (osInfo.name && osInfo.version) {
      return osInfo;
    }

    try {
      const electronOsVersion = await fetchFromElectron('OS_VERSION');
      osInfo.version = electronOsVersion.data?.osVersion;
      return osInfo;
    } catch (err: unknown) {
      const error = new Error(
        JSON.stringify({
          error: String(err),
          registrationDetails,
        }),
      );

      Sentry.captureException(error);
      // eslint-disable-next-line no-console
      console.error('Error while fetching OS version:', err);
    }
  }
  return undefined;
};

export default getOsInfo;
